module.exports = __webpack_public_path__ + "img/no_notification.6416f5ad.svg";